// ----------------------------------------------------------------------

const ROOTS = {
  AUTH: "/auth",
  DASHBOARD: "/dashboard",
  USER: "/user",
  PREDICTION: "/prediction",
  HISTORY: "/history",
  CONTACT: "/contactus",
  CHANGE_PASSWORD: "/change-password",
};

// ----------------------------------------------------------------------

export const paths = {
  // minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: {
    login: `/login`,
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
  },
  user: ROOTS.USER,
  prediction: ROOTS.PREDICTION,
  history: ROOTS.HISTORY,
  contactus: ROOTS.CONTACT,
  changePassword: ROOTS.CHANGE_PASSWORD,
};
